export default __webpack_public_path__ + "static/media/hibilet-organizer.451e864b.svg";